/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Select_Tier_ToastInputs */

const en_booking_select_tier_toast = /** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a ticket tier`)
};

const es_booking_select_tier_toast = /** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor selecciona un nivel de ticket`)
};

const fr_booking_select_tier_toast = /** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un niveau de ticket`)
};

const de_booking_select_tier_toast = /** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähle eine Ticket-Stufe`)
};

const id_booking_select_tier_toast = /** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan pilih tingkat tiket`)
};

/** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */
const ja_booking_select_tier_toast = en_booking_select_tier_toast;

/** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */
const zh_booking_select_tier_toast = en_booking_select_tier_toast;

/** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */
const ar_booking_select_tier_toast = en_booking_select_tier_toast;

/** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */
const it_booking_select_tier_toast = en_booking_select_tier_toast;

/** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */
const ru_booking_select_tier_toast = en_booking_select_tier_toast;

/** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */
const pt_booking_select_tier_toast = en_booking_select_tier_toast;

/** @type {(inputs: Booking_Select_Tier_ToastInputs) => LocalizedString} */
const ko_booking_select_tier_toast = en_booking_select_tier_toast;

/**
* | output |
* | --- |
* | "Please select a ticket tier" |
*
* @param {Booking_Select_Tier_ToastInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_select_tier_toast = /** @type {((inputs?: Booking_Select_Tier_ToastInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Select_Tier_ToastInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_select_tier_toast(inputs)
	if (locale === "es") return es_booking_select_tier_toast(inputs)
	if (locale === "fr") return fr_booking_select_tier_toast(inputs)
	if (locale === "de") return de_booking_select_tier_toast(inputs)
	if (locale === "ja") return ja_booking_select_tier_toast(inputs)
	if (locale === "zh") return zh_booking_select_tier_toast(inputs)
	if (locale === "ar") return ar_booking_select_tier_toast(inputs)
	if (locale === "id") return id_booking_select_tier_toast(inputs)
	if (locale === "it") return it_booking_select_tier_toast(inputs)
	if (locale === "ru") return ru_booking_select_tier_toast(inputs)
	if (locale === "pt") return pt_booking_select_tier_toast(inputs)
	return ko_booking_select_tier_toast(inputs)
});